import branding from 'shared/app/model/branding';
import { is_paid_tariff } from 'console/billing/billing-utils';
export function selectMapDashboardEnabled(state) {
    if (branding.geozones_in_paid_tariff) {
        return is_paid_tariff(state);
    }
    return branding.geozones;
}
export function selectMapDashboardActive(state) {
    return state.map_dashboard;
}
